<template>
    <div class="funnel-chart">
        <ECharts :option="getOptions()" class="echart-graph" />
    </div>
</template>
<script>
import Vue from "vue";
import { createComponent, plugin } from "echarts-for-vue";
import * as echarts from "echarts/lib/echarts";
import "echarts/lib/chart/heatmap";
import "echarts/lib/chart/funnel";
import "echarts/lib/component/tooltip";
import "echarts/lib/component/title";
import "echarts/lib/component/grid";
import "echarts/lib/component/visualMap";
import "echarts/lib/component/legend";
import "echarts/lib/component/toolbox";
import { FunnelChart } from "echarts/charts";

echarts.use([FunnelChart]);

Vue.use(plugin, { echarts });
//https://echarts.apache.org/examples/en/editor.html?c=area-stack-gradient
export default Vue.extend({
    name: "FunnelChart",
    components: {
        ECharts: createComponent({ echarts }),
    },
    props: {
        title: {
            type: String,
            default: "Funnel Chart",
        },

        legends: {
            type: Array,
            default: () => [],
        },
        series: {
            type: Array,
            default: () => [],
        },
        colors: {
            type: Array,
            default: () => [],
        },
    },
    methods: {
        getOptions() {
            return {
                title: {
                    text: this.title,
                    left: "center",
                    bottom: 20,
                    top: 20,
                },
                tooltip: {
                    trigger: "item",
                    formatter: "{b} : {c}%",
                },
                grid: {
                    left: "3%",
                    right: "4%",
                    top: "3%",
                    containLabel: true,
                },
                toolbox: {
                    feature: {
                        dataView: { readOnly: false },
                        restore: {},
                        saveAsImage: {},
                    },
                },
                legend: {
                    data: this.legends,
                },
                series: this.series,
            };
        },
    },
});
</script>

<style scoped lang="scss">
.funnel-chart {
    width: 100%;
    height: 500px;

    .echart-graph {
        width: 100%;
        height: 100%;
    }
}
</style>
